import React, { ComponentType } from "react";
import { FloatingActionButton as FAB } from "@/app/components/storybook/Button/FloatingActionButton";
import { CommonHelper } from "../../../../stories/helpers/CommonHelper";
import { colorOptions } from "../../../../stories/helpers/ColorTokenHelper";
import FloatingActionButtonProps from "@/app/interfaces/props/FloatingActionButtonProps";
import { FabLinkTypeEnum } from "../../../../enums/fabLinkTypeEnum";
import { ColorTokensEnum } from "@/enums/tokens/colorTokensEnum";

const iconMap: Record<string, ComponentType<any>> = CommonHelper.getFlattenedIcons(false);

const iconNames = CommonHelper.getSortedIconNames();

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  mainIcon = "SupportAgent",
  ...rest
}) => {
  const ResolvedIcon = iconMap[mainIcon as string] || iconMap["SupportAgent"];
  return <FAB {...rest} mainIcon={ResolvedIcon} />;
};

export default FloatingActionButton;

export const floatingActionButtonRegistration = {
  name: "Floating Action Button",
  inputs: [
    {
      name: "rows",
      type: "list",
      subFields: [
        { name: "line1", type: "string", defaultValue: "Need help?" },
        {
          name: "line2",
          friendlyName: "Line 2 Display Text",
          type: "string",
          defaultValue: "Chat with us",
        },
        {
          name: "line2LinkType",
          type: "string",
          enum: [
            { label: "No link", value: FabLinkTypeEnum.NONE },
            { label: "Phone (call)", value: FabLinkTypeEnum.PHONE },
            { label: "SMS (text)", value: FabLinkTypeEnum.SMS },
            { label: "WhatsApp", value: FabLinkTypeEnum.WHATSAPP },
            { label: "Email", value: FabLinkTypeEnum.EMAIL },
            { label: "Website / URL", value: FabLinkTypeEnum.URL },
          ],
          defaultValue: FabLinkTypeEnum.NONE,
          helperText: "What happens when line 2 is clicked.",
        },
        {
          name: "line2Value",
          type: "string",
          helperText:
            "Phone / SMS / WhatsApp: digits, e.g. +15551234567. Email: hello@example.com. URL: example.com or https://example.com.",
        },
        {
          name: "line2OpenInNewTab",
          type: "boolean",
          defaultValue: false,
        },
      ],
      defaultValue: [{ line1: "Need help?", line2: "Chat with us" }],
    },
    {
      name: "initialOpen",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "mainIcon",
      type: "string",
      enum: iconNames,
      defaultValue: "SupportAgent",
    },
    {
      name: "buttonColor",
      type: "string",
      enum: colorOptions,
      defaultValue: ColorTokensEnum.INTERACTIVE,
    },
    {
      name: "line1Color",
      type: "string",
      enum: colorOptions,
      defaultValue: ColorTokensEnum.DARKEST_GREY,
    },
    {
      name: "line2Color",
      type: "string",
      enum: colorOptions,
      defaultValue: ColorTokensEnum.INTERACTIVE,
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/menu-round.svg",
  description:
    "A floating action button that expands to show a menu of contact rows",
};
